import { Injectable } from '@angular/core';

import {
  ResourceActivate,
  ResourceCreated,
  ResourceDeactivate,
  ResourceUpdated,
} from '../events/resource.events';
import { ResourceEventProvider } from '../events/resource-event.provider';
import { ResourceRepository } from '../repositories/resource.repository';
import { Resource, ResourceCategory, ResourceStatus } from './resource';

@Injectable()
export class ResourceCommands {
  constructor(
    private repository: ResourceRepository,
    private resourceEventProvider: ResourceEventProvider,
  ) {
    // Nada
  }

  async create(resource: Resource): Promise<Resource> {
    const createdResource = await this.repository.create(resource);
    this.resourceEventProvider.dispatch(new ResourceCreated(createdResource));
    return createdResource;
  }

  async update(resource: Resource): Promise<Resource> {
    const updatedResource = await this.repository.save(resource);
    this.resourceEventProvider.dispatch(new ResourceUpdated(updatedResource));
    return updatedResource;
  }

  async activate(resource: Resource): Promise<Resource> {
    let activatedResource = resource.copyWith({
      status: 'active',
    } as Resource);
    activatedResource = await this.repository.save(activatedResource);
    this.resourceEventProvider.dispatch(
      new ResourceActivate(activatedResource),
    );
    return activatedResource;
  }

  async deactivate(resource: Resource): Promise<Resource> {
    let deactivatedResource = resource.copyWith({
      status: 'inactive',
    } as Resource);
    deactivatedResource = await this.repository.save(deactivatedResource);
    this.resourceEventProvider.dispatch(
      new ResourceDeactivate(deactivatedResource),
    );
    return deactivatedResource;
  }

  async findAll(
    filter: {
      category: ResourceCategory | undefined;
      status: ResourceStatus | undefined;
    },
    lastId: string | undefined,
  ): Promise<Resource[]> {
    return this.repository.findAll(filter, lastId);
  }

  async findAllReplay(lastId: string | undefined): Promise<Resource[]> {
    return this.repository.findAllReplay(lastId);
  }

  async findAllUpcoming(lastId: string | undefined): Promise<Resource[]> {
    return this.repository.findAllUpcoming(lastId);
  }

  async savePicture(filename: string, base64Image: string) {
    return await this.repository.savePicture(filename, base64Image);
  }

  async deletePicture(path: string) {
    await this.repository.deletePicture(path);
  }
}
